function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m42.994 66.014a1 1 0 0 1 -.707-.293l-30.208-30.208a1 1 0 0 1 -.281-.863l3.486-22.075a1 1 0 0 1 .832-.832l22.074-3.486a1 1 0 0 1 .863.281l30.208 30.208a1 1 0 0 1 0 1.414l-25.561 25.561a1 1 0 0 1 -.706.293zm-29.141-31.556 29.141 29.142 24.146-24.147-29.14-29.14-20.854 3.292z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m25.566 27.131a5.105 5.105 0 1 1 3.612-1.494 5.092 5.092 0 0 1 -3.612 1.494zm0-8.213a3.108 3.108 0 1 0 2.2.911 3.088 3.088 0 0 0 -2.2-.912z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m5.807 35.423-1.267-2.718a1 1 0 0 1 .031-.907l10.829-19.551 1.75.969-10.583 19.105 1.053 2.256z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m23.5 72a1 1 0 0 1 -.906-.577l-14.978-32.123 1.813-.846 14.555 31.217 16.47-7.68.846 1.809-17.376 8.1a1 1 0 0 1 -.424.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m23.124 23.9a8.182 8.182 0 0 1 -1.832-.225l.447-1.949c.824.188 2.325.387 3.12-.407.779-.779.776-2.409-.01-4.471a21.845 21.845 0 0 0 -5-7.258c-4.932-4.932-10.14-6.6-11.729-5.011s.079 6.8 5.011 11.729q.5.494 1 .952l-1.342 1.483q-.541-.49-1.072-1.021c-5.579-5.577-7.733-11.836-5.012-14.557s8.98-.567 14.558 5.011a23.846 23.846 0 0 1 5.455 7.96c1.1 2.873.938 5.216-.444 6.6a4.263 4.263 0 0 1 -3.15 1.164z"
});

var SvgPriceTags = function SvgPriceTags(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 74 74",
    fill: "#000",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPriceTags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/price-tags.06da63b7.svg";
export { ForwardRef as ReactComponent };